export function interopDefault(mod: any) {
  return mod.default || mod
}
